// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"b7740e1a","357":"517c509d","578":"962a939f","834":"7f21e543"}[chunkId] + ".chunk.js";
};